import React, { useEffect, useRef, useState } from 'react'
import Button from '@mui/material/Button';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Checkbox, Chip, Dialog, DialogActions, DialogContent, Divider, FormControl, FormHelperText, Grid, IconButton, InputLabel, ListItemText, MenuItem, Select, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography, Table, TableHead, TableBody, TableRow, TableCell, Paper, TableContainer } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLeadData } from '../../store/LeadSlice';
import { FEED_TYPE, LEAD_TYPE, AVAILABLE_INTEGRATIONS, LEADS_CATEGORY } from '../../utils/constant';
import { toast } from 'react-toastify';
import { CloseRounded } from '@mui/icons-material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import EmailIcon from '@mui/icons-material/Email';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { fetchDomainList, fetchLocations } from '../../store/domainSlice';

export default function LeadExport({ leadCategory, setLeadCategory, integration, setIntegration, setPage, currentLocations, setCurrentLocations, currentDomain, setCurrentDomain, numSelected, selected, setSelected, isFilterClicked, open, applyFilter, tabValue, setTabValue, setOpen, title, setCurrentReplyType, curretReplyType, handleFeedTypeChange, intialLeadCount, currentLeadType, handleLeadTypeChange, currentIndustry, setCurrentIndustry, handleChange, currentPlatform, currentFeedType, handlePlatformChange, handleSelectAllClick, setCurrentPlatform, setCurrentFeedType, setCurrentLeadType }) {
    const dispatch = useDispatch();
    const selectRef = useRef();

    const [availableDataCount, setavailableDataCount] = useState(0)
    const [dialogOpen, setDialogOpen] = useState(false)
    const [exportVarient, setExportVarient] = useState(null)
    const [isButtonDisabled, setIsButtonDisabled] = useState(true)
    const industries = useSelector((state) => state.industryReducer.industryList)
    const domains = useSelector((state) => state.domainReducer.domainList)
    const platforms = useSelector((state) => state.platformReducer.platformList)
    const fbLocations = useSelector((state) => state.domainReducer.fbLocations)

    const clients = useSelector((state) => state.clientReducer.clientList)
    const validationSchema = Yup.object({
        client_id: !isFilterClicked
            ? Yup.string().required("Client is required")
            : Yup.string(), num_leads: Yup.number().required("Number of leads is required").min(1, "The Minimum number of leads should be greater than 0.").max(1000, "The number should not be greater then 1000"),
    });


    const handleExportLeads = () => {
        let payload;
        if (numSelected > 0) {
            payload = {
                client_id: formik.values.client_id,
                leads_uuids: selected,
                export_type: exportVarient,
                ...(integration?.length && {  source: integration.filter(i => i !== 'all') }),
            }
        } else {

            payload = {
                client_id: formik.values.client_id,
                industry_id: currentIndustry,
                export_type: exportVarient,
                // is_replied: curretReplyType === "all" ? "all" : curretReplyType ? true : false,
                leads_for: availableDataCount.map(platform => ({
                    platform_id: platform?.platform_id,
                    num_leads: platform?.num_leads
                })),
                ...(currentLeadType !== 0 && { comment_type: currentLeadType }),
                ...(integration?.length && { source: integration.filter(i => i !== 'all') }),
            };
        };

        exportLeads(payload)
    }
    const initialValues = {
        industry_id: [],
        client_id: "",
        platform: [],
        num_leads: intialLeadCount,
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: async (values) => {

            if (isFilterClicked) {
                if (tabValue) {
                    applyFilter(values.client_id === 0
                        ? clients?.map(c => c.id) ?? []
                        : values.client_id, "filter")
                }
                else {
                    applyFilter(values.client_id === 0
                        ? clients?.map(c => c.id) ?? []
                        : values.client_id, "filter")
                }
                setOpen(false);
            } else {
                let payload;
                if (numSelected > 0) {
                    payload = {
                        client_id: formik.values.client_id,
                        leads_uuids: selected,
                        export_type: exportVarient,
                        ...(integration?.length && { source: integration.filter(i => i !== 'all') }),
                    }

                } else {
                    const updatedLocation = currentLocations?.filter((item) => item !== 'all')
                    const updatedPlatform = currentPlatform?.filter((item) => item !== 'all')
                    payload = {
                        client_id: values.client_id,
                        industry_id: currentIndustry,
                        num_leads: values.num_leads,
                        export_type: exportVarient,
                      
                        location_ids: updatedLocation,
                        // is_replied: curretReplyType === "all" ? "all" : curretReplyType ? true : false,
                        leads_for: updatedPlatform.map(platform => ({
                            platform_id: platform,
                            num_leads: values.num_leads
                        })),
                        ...(currentLeadType !== 0 && { comment_type: currentLeadType }),
                        ...(integration?.length && { source: integration.filter(i => i !== 'all') }),
                    };
                }
                exportLeads(payload)
                setOpen(false);

            }
        },
    });
    const exportLeads = async (payload) => {
        const token = localStorage.getItem('userAuthToken');
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/leads/export_leads?export_type=${payload.export_type}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                if (exportVarient === "download") {

                    const blob = await response.blob();
                    const downloadUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = 'exported_leads.xlsx';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    toast.success("Leads shared over email successfully.")
                }
                setCurrentIndustry([])
                setCurrentLocations([])
                setCurrentPlatform([])
                handleFeedTypeChange({ target: { value: 0 } })
                handleLeadTypeChange({ target: { value: 0 } })
                handlePlatformChange({ target: { value: [] } })
                formik.resetForm({ values: { ...initialValues } });
                applyFilter(null, "export")
            } else {
                const errorData = await response.json();
                if (errorData.status_code === 400) {
                    toast.error(errorData?.details || "Failed to export leads!");
                }
                if (errorData.status_code === 409) {
                    setDialogOpen(true)
                    setavailableDataCount(errorData?.data?.leads_for)
                }
            }
        } catch (error) {
            console.log("error in export", error);
        }
    }
    useEffect(() => {
        if (formik.errors && Object.keys(formik.errors).length > 0) {
            formik.resetForm();
        }
    }, [open])
    // add if needed, removed in code optimization 
    // useEffect(() => {
    //     if (currentPlatform.length > 0) {
    //         const availablePlatforms = platforms.filter((platform) => currentPlatform.includes(platform.id)).map((platform) => platform.id);
    //         handlePlatformChange({ target: { value: availablePlatforms } });
    //     }
    // }, [platforms])

    useEffect(() => {
        formik.setFieldValue('client_id', "")
    }, [tabValue, title])
    const allOptionId = 'all';
    const allOptionLabel = 'All';
    const allPlatformIds = platforms?.map((ele) => ele.id);

    const allLocationIds = [
        ...new Set(
            fbLocations?.flatMap(client =>
                client.location?.map(location => location.id) || []
            )
        )
    ];
    useEffect(() => {
        const updatedPlatform = currentPlatform?.filter((item) => item !== "all")
        dispatch(fetchDomainList(`&platform_ids=${updatedPlatform?.join(",")}`))

    }, [currentPlatform])

    useEffect(() => {
        if (domains?.length) {
            const updatedDomain = domains.map((item) => item.id)
            dispatch(fetchLocations(`&domain_ids=${updatedDomain?.join(",")}`))
        }
    }, [domains])

    const allLocations = fbLocations
        .filter(client => client?.location?.length)
        .flatMap(client => client.location);

    useEffect(() => {
        // Clear feed type if integration is not Facebook
        if (integration !== 'Facebook' && currentFeedType) {
            setCurrentFeedType(0);
        }
    }, [integration]);

    const allIntegrationOptionId = 'all';
    const allIntegrationLabel = 'All';
    const allIntegrationNames = AVAILABLE_INTEGRATIONS?.map((ele) => ele.name);
    const allCategoryNames = LEADS_CATEGORY?.map((ele) => ele.name);

    // Handler to remove a row from availableDataCount
    // const handleRemoveAvailableRow = (idx) => {
    //     if (Array.isArray(availableDataCount)) {
    //         setavailableDataCount(prev => prev.filter((_, i) => i !== idx));
    //     }
    // };
    const handleRemoveAvailableRow = (idx) => {
        if (Array.isArray(availableDataCount)) {
            const updatedList = availableDataCount.filter((_, i) => i !== idx);
            setavailableDataCount(updatedList);
            if (updatedList.length === 0) {
                setDialogOpen(false); // or whatever state you want to update
            }
        }
    };
    return (
        <Box className="position-relative h-100">
            <Dialog
                open={dialogOpen}
                onClose={() => { setDialogOpen(false) }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <Grid item size={{ lg: 3, md: 6, sm: 12, xs: 12 }}>
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                Confirmation
                            </Typography>
                            <Divider />
                            {Array.isArray(availableDataCount) ? (
                                <>
                                    <Typography variant="body1" className='mt-3' gutterBottom>
                                        The following platforms have available leads:
                                    </Typography>
                                    <Box sx={{ mt: 2, mb: 2 }}>
                                        <TableContainer component={Paper} style={{ overflowX: 'auto' }}>
                                            <Table size="small" className="mb-3">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Platform Name</TableCell>
                                                        <TableCell>Available Leads</TableCell>
                                                        <TableCell align="center"></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {availableDataCount.map((row, idx) => (
                                                        <TableRow key={idx}>
                                                            <TableCell>{row.platform_name}</TableCell>
                                                            <TableCell>{row.num_leads}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton size="small" color="primary" onClick={() => handleRemoveAvailableRow(idx)}>
                                                                    <CloseRounded fontSize="small" />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>
                                    <Typography variant="body1" className='mt-3' gutterBottom>
                                        Are you sure you want to export the available leads?
                                    </Typography>
                                </>
                            ) : (
                                <Typography variant="body1" className='mt-3' gutterBottom>
                                    {`Only ${availableDataCount} unsold Facebook leads available, requested ${formik?.values?.num_leads}, Are you still want export available leads ?`}
                                </Typography>
                            )}
                        </Box>
                    </Grid>
                    <Box display="flex" justifyContent="center" mt={3} gap={1}>
                        <Button onClick={() => { setDialogOpen(false) }} variant="outlined" color='primary'  >No</Button>
                        <Button onClick={() => { handleExportLeads(); setDialogOpen(false) }} variant="contained" color='primary' type="submit">
                            Yes
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
            <form onSubmit={formik.handleSubmit} >
                <Box className="p-3 d-flex justify-content-between">
                    <Typography variant="h6" gutterBottom>
                        {isFilterClicked ? title : numSelected === 0 ? title : 'Export Selected Leads'}
                        {/* {numSelected === 0 ? title : 'Export Selected Leads'} */}
                    </Typography>
                    {<Button variant="outlined" className='mb-2' startIcon={<RestartAltIcon color='primary' />}
                        onClick={() => {
                            const data = {
                                page: 1,
                                page_size: intialLeadCount,
                                is_sold:tabValue
                            }
                            setPage(0)
                            dispatch(fetchLeadData(data)).then((res) => {
                            }).catch((err) => {
                                console.log("error in fetching lead data", err);
                            })
                            formik.resetForm()
                            setCurrentReplyType("")
                            setCurrentLocations([])
                            setIntegration([])
                            handleFeedTypeChange({ target: { value: 0 } })
                            handleLeadTypeChange({ target: { value: 0 } })
                            handlePlatformChange({ target: { value: [] } })
                            handleChange({ target: { value: [] } })
                            setOpen(false)
                        }}
                    > Clear Filters</Button>}
                </Box>
                <Divider />
                <div className='role-form-scroller px-3'>
                    {(!isFilterClicked || tabValue) ?
                        <FormControl fullWidth className='mt-3 min-with-select'
                            error={formik.touched.client_id && Boolean(formik.errors.client_id)}
                            required
                        >
                            <InputLabel id="client_id">Client</InputLabel>
                            <Select
                                fullWidth
                                labelId="client_id"
                                id="client_id"
                                name='client_id'
                                label="Client"
                                defaultValue='select'
                                value={formik.values.client_id}
                                onChange={formik.handleChange}
                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    }
                                }}
                                endAdornment={
                                    formik.values.client_id ? (
                                        <IconButton
                                            size="small"
                                            className='mr-4'
                                            onClick={() => formik.setFieldValue('client_id', '')}
                                            onMouseDown={(event) => event.stopPropagation()} // Prevents the select dropdown from opening
                                        >
                                            <CloseRounded />
                                        </IconButton>
                                    ) : null
                                }
                                onBlur={formik.handleBlur}
                                error={formik.touched.client_id && Boolean(formik.errors.client_id)}
                                helperText={formik.touched.client_id && formik.errors.client_id}
                            >
                                {tabValue === 1 && <MenuItem value={0}>All</MenuItem>}
                                {(!clients || clients?.length === 0) && (
                                    <MenuItem disabled color="primary">
                                        No Client found.
                                    </MenuItem>
                                )}
                                {clients?.length && clients?.map((ele) => <MenuItem value={ele.id}>{ele.email}</MenuItem>)}
                            </Select>
                            {formik.touched.client_id && formik.errors.client_id && (
                                <FormHelperText className='text-danger'>{formik.errors.client_id}</FormHelperText>
                            )}
                        </FormControl> : <></>}
                    {numSelected === 0 &&
                        <FormControl fullWidth className='mt-3'>
                            <InputLabel id="integration">Source</InputLabel>
                            <Select
                                labelId="integration"
                                id="integration"
                                name='integration'
                                label="Source"
                                multiple
                                value={integration}
                                onChange={e => {
                                    const value = e.target.value;
                                    const isAllSelected = integration.includes(allIntegrationOptionId);
                                    const justClickedAll = value.includes(allIntegrationOptionId) && !isAllSelected;
                                    const justUnclickedAll = !value.includes(allIntegrationOptionId) && isAllSelected;
                                    setIsButtonDisabled(false)
                                    if (justClickedAll) {
                                        setIntegration([allIntegrationOptionId, ...allIntegrationNames]);
                                    } else if (justUnclickedAll) {
                                        setIntegration([]);
                                    } else {
                                        const filtered = value.filter(val => val !== allIntegrationOptionId);
                                        if (filtered.length === allIntegrationNames.length) {
                                            setIntegration([allIntegrationOptionId, ...filtered]);
                                        } else {
                                            setIntegration(filtered);
                                        }
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    }
                                }}
                                // endAdornment={
                                //     integration.length ? (
                                //         <IconButton
                                //             size="small"
                                //             className='mr-4'
                                //             onClick={() => setIntegration([])}
                                //             onMouseDown={event => event.stopPropagation()}
                                //         >
                                //             <CloseRounded />
                                //         </IconButton>
                                //     ) : null
                                // }
                                renderValue={(selected) => {
                                    if (selected.length === 0) {
                                        return <Typography color="textSecondary">Select integrations</Typography>;
                                    } else {
                                        return (
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                                {integration.filter((id) => id !== allIntegrationOptionId).map((name) => (
                                                    <Chip
                                                        className="role-permission mr-2"
                                                        key={name}
                                                        label={name}
                                                        onMouseDown={(event) => event.stopPropagation()}
                                                        onDelete={() => {
                                                            const updated = integration.filter((item) => item !== name && item !== allIntegrationOptionId);
                                                            setIntegration(updated);
                                                        }}
                                                    />
                                                ))}
                                            </Box>
                                        );
                                    }
                                }}
                            >
                                <MenuItem key={allIntegrationOptionId} value={allIntegrationOptionId}>
                                    <Checkbox checked={integration.includes(allIntegrationOptionId)} />
                                    <ListItemText primary={allIntegrationLabel} />
                                </MenuItem>
                                {AVAILABLE_INTEGRATIONS?.length && AVAILABLE_INTEGRATIONS?.map((ele) => (
                                    <MenuItem key={ele.name} value={ele.name}>
                                        <Checkbox checked={integration.includes(ele.name)} />
                                        <ListItemText primary={ele.name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>}
                    {numSelected === 0 &&
                        <FormControl fullWidth className='mt-3'>
                            <InputLabel id="category">Category</InputLabel>
                            <Select
                                labelId="category"
                                id="category"
                                name='category'
                                label="Category"
                                multiple
                                value={leadCategory}
                                onChange={e => {
                                    const value = e.target.value;
                                    const isAllSelected = leadCategory.includes(allOptionId);
                                    const justClickedAll = value.includes(allOptionId) && !isAllSelected;
                                    const justUnclickedAll = !value.includes(allOptionId) && isAllSelected;
                                    setIsButtonDisabled(false)
                                    if (justClickedAll) {
                                        setLeadCategory([allOptionId, ...allCategoryNames]);
                                    } else if (justUnclickedAll) {
                                        setLeadCategory([]);
                                    } else {
                                        const filtered = value.filter(val => val !== allOptionId);
                                        if (filtered.length === allCategoryNames.length) {
                                            setLeadCategory([allOptionId, ...filtered]);
                                        } else {
                                            setLeadCategory(filtered);
                                        }
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    }
                                }}

                                renderValue={(selected) => {
                                    if (selected.length === 0) {
                                        return <Typography color="textSecondary">Select Category</Typography>;
                                    } else {
                                        return (
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                                {leadCategory.filter((id) => id !== allOptionId).map((name) => (
                                                    <Chip
                                                        className="role-permission mr-2"
                                                        key={name}
                                                        label={name}
                                                        onMouseDown={(event) => event.stopPropagation()}
                                                        onDelete={() => {
                                                            const updated = leadCategory.filter((item) => item !== name && item !== allOptionId);
                                                            setLeadCategory(updated);
                                                        }}
                                                    />
                                                ))}
                                            </Box>
                                        );
                                    }
                                }}
                            >
                                <MenuItem key={allOptionId} value={allOptionId}>
                                    <Checkbox checked={leadCategory.includes(allOptionId)} />
                                    <ListItemText primary={allOptionLabel} />
                                </MenuItem>
                                {LEADS_CATEGORY?.length && LEADS_CATEGORY?.map((ele) => (
                                    <MenuItem key={ele.name} value={ele.name}>
                                        <Checkbox checked={leadCategory.includes(ele.name)} />
                                        <ListItemText primary={ele.name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>}
                    {(numSelected === 0 || isFilterClicked) && <>
                        <FormControl className="mt-3 min-with-select" fullWidth>
                            <InputLabel id="industry_id">Industry</InputLabel>
                            <Select
                                labelId="industry_id"
                                id="industry_id"
                                multiple
                                name="industry_id"
                                label="Industry"
                                value={currentIndustry}
                                onChange={(event) => {
                                    handleChange(event)
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    }
                                }}
                                // endAdornment={
                                //     currentIndustry?.length ? (
                                //         <IconButton
                                //             size="small"
                                //             className='mr-4'
                                //             onClick={() => handleChange({ target: { name: 'industry_id', value: [] } })}
                                //             onMouseDown={(event) => event.stopPropagation()} // Prevents the select dropdown from opening
                                //         >
                                //             <CloseRounded />
                                //         </IconButton>
                                //     ) : null
                                // }
                                renderValue={(selected) => {
                                    if (selected.length === 0) {
                                        return <Typography color="textSecondary">Select industries</Typography>;
                                    } else {
                                        return (<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                            {currentIndustry?.map((id) => {
                                                const selectedIndustry = industries.find((ele) => ele?.id === id);
                                                return (
                                                    <Chip
                                                        className="role-permission mr-2"
                                                        key={id}
                                                        label={selectedIndustry?.title}
                                                        onMouseDown={(event) => {
                                                            event.stopPropagation();
                                                        }}
                                                        onDelete={(event) => {
                                                            const updatedIndustry = currentIndustry.filter((item) => item !== id);
                                                            // const updatedIndustry = ?.filter((item) => item.ind !== id);
                                                            handleChange({ target: { name: 'industry_id', value: updatedIndustry } });
                                                        }}
                                                    />
                                                );
                                            })}
                                        </Box>)
                                    }
                                }}
                            >
                                {(!industries || industries?.length === 0) && (
                                    <MenuItem disabled color="primary">
                                        No Industry found.
                                    </MenuItem>
                                )}
                                {industries?.length &&
                                    industries.map((ele) => {
                                        return (<MenuItem key={ele.id} value={ele.id}>
                                            <Checkbox
                                                checked={currentIndustry.includes(ele.id)}
                                            />
                                            <ListItemText primary={ele.title} />
                                        </MenuItem>)
                                    })}
                            </Select>
                        </FormControl>

                        <FormControl className="mt-3 min-with-select" fullWidth>
                            <InputLabel id="platform">Platform</InputLabel>
                            <Select
                                labelId="platform"
                                id="platform"
                                multiple
                                name="platform"
                                label="platform"
                                value={currentPlatform}
                                onChange={(event) => {
                                    const value = event.target.value;

                                    const isAllSelected = currentPlatform.includes(allOptionId);
                                    const justClickedAll = value.includes(allOptionId) && !isAllSelected;
                                    const justUnclickedAll = !value.includes(allOptionId) && isAllSelected;
                                    if (justClickedAll) {
                                        handlePlatformChange({ target: { value: [allOptionId, ...allPlatformIds] } });
                                    } else if (justUnclickedAll) {
                                        handlePlatformChange({ target: { value: [] } });
                                    } else {
                                        const filtered = value.filter(val => val !== allOptionId);

                                        if (filtered.length === allPlatformIds.length) {
                                            handlePlatformChange({ target: { value: [allOptionId, ...filtered] } })
                                        } else {
                                            handlePlatformChange({ target: { value: filtered } });
                                        }
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    }
                                }}
                                // endAdornment={
                                //     currentPlatform?.length ? (
                                //         <IconButton
                                //             size="small"
                                //             className='mr-4 ml-0'
                                //             onClick={() => handlePlatformChange({ target: { value: [] } })}
                                //             onMouseDown={(event) => event.stopPropagation()} // Prevents the select dropdown from opening
                                //         >
                                //             <CloseRounded />
                                //         </IconButton>
                                //     ) : null
                                // }
                                inputRef={selectRef}
                                renderValue={(selected) => {
                                    return (<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }} className="multi-selection-box-wrapper">
                                        {currentPlatform?.map((id) => {
                                            const selectedIndustry = platforms.find((ele) => ele?.id === id);
                                            return (
                                                selectedIndustry && <Chip
                                                    className="role-permission mr-2"
                                                    key={id}
                                                    onMouseDown={(event) => {
                                                        event.stopPropagation(); // Prevent the Select dropdown from opening
                                                    }}
                                                    label={selectedIndustry?.name}
                                                    onDelete={(event) => {
                                                        event.stopPropagation(); // Prevent the Select dropdown from opening
                                                        const updatedPlatform = currentPlatform.filter(
                                                            item => item !== id && item !== "all"
                                                        );
                                                        handlePlatformChange({ target: { value: updatedPlatform } }); // Trigger change handler if needed
                                                    }}
                                                />
                                            );
                                        })}
                                    </Box>)
                                }}
                            >
                                {(!platforms || platforms?.length === 0) && (
                                    <MenuItem disabled color="primary">
                                        No Platforms found.
                                    </MenuItem>
                                )}
                                {platforms?.length &&
                                    <MenuItem key={allOptionId} value={allOptionId}>
                                        <Checkbox checked={currentPlatform?.includes(allOptionId)} />
                                        <ListItemText primary={allOptionLabel} />
                                    </MenuItem>}
                                {platforms?.length &&
                                    platforms.map((ele) => {
                                        return (<MenuItem key={ele.id} value={ele.id}>
                                            <Checkbox
                                                checked={currentPlatform.includes(ele.id)}
                                            />
                                            <ListItemText primary={ele.name} />
                                        </MenuItem>)
                                    })}
                            </Select>
                        </FormControl>

                        <FormControl fullWidth className="mt-3 location-select-wrapper"
                        >
                            <InputLabel id="location_ids">Location & Domain</InputLabel>
                            <Select
                                labelId="location_ids"
                                id="location_ids"
                                name="location_ids"
                                label="Location & Domain"
                                className=''
                                multiple
                                value={currentLocations || []} // must stay array
                                onChange={(event) => {
                                    const value = event.target.value;
                                    setIsButtonDisabled(false)
                                    const isAllSelected = currentLocations.includes(allOptionId);
                                    const justClickedAll = value.includes(allOptionId) && !isAllSelected;
                                    const justUnclickedAll = !value.includes(allOptionId) && isAllSelected;
                                    if (justClickedAll) {
                                        setCurrentLocations([allOptionId, ...allLocationIds]);
                                    } else if (justUnclickedAll) {
                                        setCurrentLocations([]);
                                    } else {
                                        const filtered = value.filter(val => val !== allOptionId);

                                        if (filtered?.length === allLocationIds?.length) {
                                            setCurrentLocations([allOptionId, ...filtered])
                                        } else {
                                            setCurrentLocations(filtered);
                                        }
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    }
                                }}
                                inputRef={selectRef}

                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }} className="multi-selection-box-wrapper">
                                        {currentLocations
                                            .filter((id) => id !== allOptionId) // exclude "all"
                                            .map((id) => {
                                                const selectedLocation = allLocations.find((loc) => loc.id === id);
                                                if (!selectedLocation) return null;

                                                return (
                                                    <Chip
                                                        className="role-permission mr-2"
                                                        key={id}
                                                        onMouseDown={(event) => event.stopPropagation()}
                                                        label={selectedLocation.display_name || 'Unknown'}
                                                        onDelete={(event) => {
                                                            event.stopPropagation();
                                                            setIsButtonDisabled(false)
                                                            const updatedLocation = currentLocations.filter(
                                                                (item) => item !== id && item !== allOptionId
                                                            );
                                                            setCurrentLocations(updatedLocation);
                                                        }}
                                                    />
                                                );
                                            })}
                                    </Box>
                                )}
                            >
                                <MenuItem key={allOptionId} value={allOptionId}>
                                    <Checkbox size='small' checked={currentLocations?.includes(allOptionId)} />
                                    <ListItemText primary={allOptionLabel} />
                                </MenuItem>
                                {fbLocations?.length > 0 &&
                                    fbLocations.map((ele) => (
                                        ele?.location?.length && [
                                            <Typography variant='body1' color={'primary'} className='ml-4 mt-0 mb-0' key={`${ele.key}-header`}>{ele.key}</Typography>,
                                            ...ele.location.map((loc) => (
                                                <MenuItem key={loc.id} value={loc.id}>
                                                    <Checkbox size='small' checked={currentLocations.includes(loc.id)} />
                                                    <ListItemText primary={
                                                        <Typography variant='body2' className='mt-0 mb-0' key={`${loc.display_name}-header`}>{loc.display_name}</Typography>
                                                    } />
                                                </MenuItem>
                                            ))
                                        ]
                                    ))
                                }
                            </Select>
                        </FormControl>
                        <FormControl fullWidth className='mt-3 mb-3' >
                            <InputLabel id="comment_type">Lead Type</InputLabel>
                            <Select
                                labelId="comment_type"
                                id="comment_type"
                                name='comment_type'
                                label="Lead Type"
                                value={currentLeadType}
                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    }
                                }}
                                endAdornment={
                                    currentLeadType ? (
                                        <IconButton
                                            size="small"
                                            className='mr-4'
                                            onClick={() => handleLeadTypeChange({ target: { value: 0 } })}
                                            onMouseDown={(event) => event.stopPropagation()} // Prevents the select dropdown from opening
                                        >
                                            <CloseRounded />
                                        </IconButton>
                                    ) : null
                                }
                                onChange={(e) => { handleLeadTypeChange(e); setIsButtonDisabled(false) }}
                            >
                                <MenuItem value={0}>All</MenuItem>
                                {LEAD_TYPE?.length && LEAD_TYPE?.map((ele) => (
                                    <MenuItem key={ele?.key} value={ele?.key}>{ele?.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {Array.isArray(integration) && integration.includes('Facebook') && (
                            <FormControl fullWidth className='mb-1' >
                                <InputLabel id="feed_type">Feed Type</InputLabel>
                                <Select
                                    labelId="feed_type"
                                    id="feed_type"
                                    name='feed_type'
                                    label="Feed Type"
                                    value={currentFeedType}
                                    onChange={(e) => { handleFeedTypeChange(e); setIsButtonDisabled(false) }}
                                    MenuProps={{
                                        PaperProps: {
                                            className: "mui-select-menu",
                                        }
                                    }}
                                    endAdornment={
                                        currentFeedType ? (
                                            <IconButton
                                                size="small"
                                                className='mr-4'
                                                onClick={() => handleFeedTypeChange({ target: { value: 0 } })}
                                                onMouseDown={(event) => event.stopPropagation()} // Prevents the select dropdown from opening
                                            >
                                                <CloseRounded />
                                            </IconButton>
                                        ) : null
                                    }
                                >
                                    <MenuItem value={0}>All</MenuItem>
                                    {FEED_TYPE?.length && FEED_TYPE?.map((ele) => (
                                        <MenuItem key={ele?.key} value={ele?.key}>{ele?.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                        {!isFilterClicked && <TextField
                            fullWidth
                            required
                            type='number'
                            id="num_leads"
                            name="num_leads"
                            label="Per Platform Lead Count"
                            margin="normal"
                            variant="outlined"
                            className='mt-1 mb-0'
                            value={formik.values.num_leads}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.num_leads && Boolean(formik.errors.num_leads)}
                            helperText={formik.touched.num_leads && formik.errors.num_leads}
                        />}
                        {/* <FormControl margin="normal" fullWidth className='mt-3'  >
                            <Box className="align-items-center" >
                                <Box display="flex" alignItems="center" className="mb-3">
                                    <Typography color='primary' size="small" className='mr-2'>Auto reply sent</Typography>
                                    <Tooltip title="Selecting YES will show leads that have already received a reply from the bot.
                                                Selecting NO will show leads that have not been replied to by the bot.
                                                Selecting ALL will display all leads, regardless of bot responses.">
                                        <InfoIcon fontSize="small" color="primary" />
                                    </Tooltip>
                                </Box>
                                <ToggleButtonGroup
                                    exclusive
                                    value={curretReplyType}
                                    onChange={(event, newValue) => { setCurrentReplyType(newValue); setIsButtonDisabled(false) }}
                                    aria-label="Filter By Reply Type"
                                    className="mb-2 mr-2"
                                >
                                    {[{ name: "Yes", key: 1 }, { name: "No", key: 0 }, { name: "All", key: "all" }].map((perm) => (
                                        <ToggleButton key={perm.key} value={perm.key} className='px-4'>
                                            {perm.name}
                                        </ToggleButton>
                                    ))}
                                </ToggleButtonGroup>

                            </Box>
                        </FormControl>  */}
                    </>}
                </div>
                <Box className="drawer-footer mb-2 mt-3 mr-3">
                    {numSelected > 0 && !isFilterClicked && (
                        <Box className="mb-3 p-2" style={{ backgroundColor: "#fafdf3", borderRadius: "5px", border: "1px solid #ddd" }}>
                            <Typography variant="body2" color="textSecondary">
                                To export all the filtered leads, please remove the selection of specific leads. <span style={{ color: '#425e0ae8', fontWeight: '600', textDecoration: 'underline', marginLeft: '5px', cursor: 'pointer' }} onClick={handleSelectAllClick}>Remove selection</span>
                            </Typography>
                        </Box>
                    )}
                    <Box sx={{ display: 'flex', justifyContent: 'end', mb: 1 }}>
                        <Button
                            type="button"
                            variant="outlined"
                            color="primary"
                            onClick={() => { setOpen(false); }}
                            className="mt-2 mr-2"
                        >
                            Cancel
                        </Button>
                        {isFilterClicked ? (
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className="mt-2"
                                startIcon={<FilterAltIcon />}
                                disabled={
                                    !isFilterClicked ||
                                    (formik?.values?.client_id === '' && currentIndustry?.length === 0 && currentPlatform?.length === 0 && isButtonDisabled)
                                }
                            >
                                Apply
                            </Button>
                        ) : (
                            <>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    className="mt-2 mr-2"
                                    onClick={() => {
                                        setExportVarient('download');
                                    }}
                                    disabled={!isFilterClicked && formik.values.client_id === ''}

                                    startIcon={<SystemUpdateAltIcon color="white" />}
                                >
                                    Download
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        setExportVarient('share');
                                    }}
                                    className="mt-2"
                                    startIcon={<EmailIcon />}
                                    disabled={!isFilterClicked && formik.values.client_id === ''}
                                >
                                    Send Email
                                </Button>
                            </>
                        )}
                    </Box>
                </Box>
            </form>
        </Box>
    )
}